import {
  GET_MATCH_CARD_HOT_BETS_REQUEST,
  GET_MATCH_CARD_HOT_BETS_SUCCESS,
  GET_MATCH_CARD_HOT_BETS_FAILURE,
  MATCH_CARD_HOT_BETS_WS_UPDATE,
  RESET_MATCH_CARD
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  lastFetchTime: null,
  lastSocketUpdate: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCH_CARD_HOT_BETS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case GET_MATCH_CARD_HOT_BETS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null,
        lastFetchTime: Date.now()
      };

    case GET_MATCH_CARD_HOT_BETS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    case MATCH_CARD_HOT_BETS_WS_UPDATE:
      return {
        ...state,
        data: action.payload,
        lastSocketUpdate: Date.now()
      };

    case RESET_MATCH_CARD:
      return initialState;

    default:
      return state;
  }
};

